
export enum UserSelectionMethod {
	EXACT_SELECTION = 'EXACT_SELECTION',
	ALL_MATCHING_FILTERS = 'ALL_MATCHING_FILTERS'
}

